"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stricterOfReason = stricterOfReason;
/**
 * Copy for a missing generator status, for specifically those states where
 * the "effective" generator status is the stricter of (state, federal).
 */
function stricterOfReason(missing, stateName) {
    const stricterOf = `Storage deadlines in ${stateName} depend on the generator status, which is the stricter of the federal status and ` +
        `${stateName}'s own determination`;
    if (!missing.federal) {
        return (`${stricterOf}. The federal status is known, but the ${stateName} status is not. It is ` +
            "calculated from the waste the facility generates.");
    }
    if (!missing.state) {
        return (`${stricterOf}. The ${stateName} status is known, but the federal status is not. It ` +
            "comes from the facility's EPA registration or its shipment history.");
    }
    return (`${stricterOf}, and neither is known. The federal status comes from the facility's ` +
        `EPA registration or its shipment history; the ${stateName} status is calculated from the ` +
        "waste the facility generates.");
}
//# sourceMappingURL=stricterOfReason.js.map